// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"c8a": "primer-react-css","xzc": "primer-react-brand-css",}[chunkId] + "." + {"c8a": "f292d8d07fbc3b0d","xzc": "1e95b4e57c24dd3a",}[chunkId] + ".module.css"
}